import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { createNewEmployee } from '../../store/actions';

import BaseModal from '../../components/BaseModal';
import BaseFormWithAction from '../../components/BaseFormWithAction';

import {
  REQUIRED,
  EMAIL,
  PHONE,
  ALPHABETICAL
} from '../../utils/formValidation';

const CreateNewEmployeeModal = (props) => {
  const submit = async (data) => {
    await props.createNewEmployee({...data, status: 'active'}, (to) => props.history.push(`/employees/${to}`));
  }

  const formData = [
    {
      name: 'firstName',
      labelName: 'First Name',
      type: 'text',
      validation: [REQUIRED, ALPHABETICAL]
    },
    {
      name: 'lastName',
      labelName: 'Last Name',
      type: 'text',
      validation: [REQUIRED, ALPHABETICAL]
    },
    {
      name: 'email',
      labelName: 'Email',
      type: 'text',
      validation: [REQUIRED, EMAIL]
    },
    {
      name: 'phone',
      labelName: 'Phone',
      type: 'text',
      validation: [REQUIRED, PHONE]
    },
    {
      name: 'address',
      labelName: 'Street Address',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'zip',
      labelName: 'Zip',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'password',
      labelName: 'Password',
      type: 'password',
      validation: [REQUIRED]
    },
    {
      name: 'role',
      labelName: 'Role',
      type: 'select',
      selectOptions: {
        options: ['manager', 'standard'],
        prop: 'role'
      },
      validation: [REQUIRED]
    },
    // {
    //   name: 'note',
    //   labelName: 'Note',
    //   type: 'textarea',
    //   validation: []
    // }
  ]

  const body = (
    <div className="create-new-employee__body">
      <h2 className="create-new-employee__title modal__body-title">
        New Employee
      </h2>
      <BaseFormWithAction
        formData={formData}
        buttonName="Add Employee"
        onSubmit={submit}
      />
    </div>
  );

  return (
    <BaseModal body={body} footer={null} onClose={props.onClose}/>
  );
}

export default connect(null, { createNewEmployee })(withRouter(CreateNewEmployeeModal));